<template>
    <a-popover
        v-model="visible"
        title="确认订单"
        trigger="click"
    >
        <template
            slot="content">
            <OrderList v-if="orderNumber > 0"/>
            <EmptyOrderList v-else/>
        </template>
        <a-button
            class="button">
            <div v-if="orderNumber > 0">
                正常订单 ({{ orderNumber }})
            </div>
            <div v-else>
                正常订单
            </div>
        </a-button>
    </a-popover>
</template>

<script>
 import Vue from 'vue';
 import Button from "ant-design-vue/lib/button";
 import Popover from "ant-design-vue/lib/popover";
 import OrderList from "./OrderList.vue"
 import EmptyOrderList from "./EmptyOrderList.vue"
 import EventBus from "../event/event-bus.js"

 Vue.component(Button.name, Button);
 Vue.component(Popover.name, Popover);

 import { mapGetters } from 'vuex'

 import { confirmOrder } from "../util/order.js"

 export default {
     name: 'ConfirmButton',
     data() {
         return {
             visible: false
         }
     },
     props: {
     },
     components: {
         OrderList,
         EmptyOrderList
     },
     computed: {
         ...mapGetters([
             "orderNumber"
         ])
     },
     created() {
         console.log("Create ConfirmButton")
     },
     mounted() {
         console.log("Mount ConfirmButton")

         EventBus.$on("confirmOrder", this.confirm)
     },
     beforeDestroy() {
         EventBus.$off("confirmOrder");
     },
     methods: {
         confirm() {
             this.visible = false
             confirmOrder(
                 this.$store.getters.orderId,
                 this.$store.getters.shoppingCommodities,
                 function() {
                     EventBus.$emit("fetchNextOrder")
                 }
             )
         }
     }
 }
</script>

<style scoped>
 .button {
     background: #5DC55C;
     color: #FFF;
     border: none;
     height: 50px;
     width: 100%;
 }
</style>
